import React from "react";
import { useSiteContent } from "../content/SiteContentContext.jsx";
import { resolveImage } from "../utils/resolveImage";

// Banda de estadísticas de la portada. Fondo de marca (gradiente) para que las tarjetas NO se
// pierdan sobre una foto ocupada; tarjetas "glass" con icon-orb, aparición escalonada (fade-up)
// y elevación al hover. Encabezado (eyebrow/título/subtítulo) OPCIONAL y editable desde el panel:
// si sus 3 campos están vacíos, no se renderiza. Todos los textos vienen del contenido (CMS).
const Awrapper = () => {
  const { awrapper, awrapperHeading } = useSiteContent();
  const heading = awrapperHeading || {};
  const hasHeading = Boolean(heading.eyebrow || heading.title || heading.subtitle);
  const items = Array.isArray(awrapper) ? awrapper : [];

  return (
    <section className="brand-gradient relative overflow-hidden text-white">
      <div className="blob-glow w-[420px] h-[420px] -top-32 -left-24" />
      <div className="blob-glow w-[380px] h-[380px] -bottom-28 -right-20" />

      <div className="relative z-[1] mx-auto w-full max-w-[1100px] px-6 py-14 md:py-20">
        {hasHeading ? (
          <div className="text-center max-w-[720px] mx-auto mb-10 md:mb-14 fade-up">
            {heading.eyebrow ? (
              <span className="eyebrow on-dark">{heading.eyebrow}</span>
            ) : null}
            {heading.title ? (
              <h2 className="mt-3 font-bold text-[26px] ss:text-[36px] leading-tight">
                {heading.title}
              </h2>
            ) : null}
            {heading.subtitle ? (
              <p className="mt-3 text-white/80 text-[17px] leading-[28px]">{heading.subtitle}</p>
            ) : null}
          </div>
        ) : null}

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((val, index) => (
            <div
              key={index}
              className="stat-card fade-up"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              {val.cover ? (
                <span className="icon-orb w-16 h-16 md:w-[72px] md:h-[72px] mb-4">
                  <img
                    src={resolveImage(val.cover)}
                    alt={val.title || val.data || ""}
                    className="w-8 h-8 md:w-10 md:h-10 object-contain"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </span>
              ) : null}
              {val.data ? <div className="stat-data">{val.data}</div> : null}
              {val.title ? <div className="stat-label">{val.title}</div> : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Awrapper;
